import React, { useEffect, useRef, useState } from "react";
import {
  BottomNavigation,
  BottomNavigationAction,
  Button,
  Badge,
} from "@mui/material";
import {
  Delete as DeleteIcon,
  Print as PrintIcon,
  Close as CloseIcon,
  Done as DoneIcon,
  MessageOutlined as MessageIcon,
  AttachFile as AttachFileIcon,
  Refresh as RefreshIcon,
  ContentCopy as ContentCopyIcon,
} from "@mui/icons-material";

import ReactToPrint from "react-to-print";
import theme from "../../../Styles/theme";
import { useFuncionarioCartorio } from "../../../Hooks/funcionarioCartorio";
import { IImovel } from "../../../Hooks/imoveis";
import { IImovelFocus } from "../../../Pages/Cartorio_Pages/App_Pages/ImovelFocus";
import { usePrefeitura } from "../../../Hooks/usePrefeitura";
import { useFuncionarioPrefeitura } from "../../../Hooks/funcionarioPrefeitura";
import { useComunicacao } from "../../../Hooks/comunicacoes";
import { HelperResponsivo } from "./styles";
import { useLocation } from "react-router";

interface Props {
  printComponent: any;
  openMensagem: () => void;
  onExcluir: () => void;
  imovel: IImovelFocus;
  enviar: () => void;
  executeAnexos: () => void;
  reenviarCartorio: () => void;
  finalizarAvaliacao: () => void;
  confirmarAvaliacaoFunction: () => void;
  duplicar: () => void;
  countAnexos: number;
  finalizado?: boolean;
  confirmarAvaliacao?: boolean;
  barrasIncorreto: boolean;
}

export const FooterImovelFocus = ({
  printComponent,
  openMensagem,
  onExcluir,
  imovel,
  enviar,
  executeAnexos,
  reenviarCartorio,
  finalizarAvaliacao,
  confirmarAvaliacaoFunction,
  duplicar,
  countAnexos,
  finalizado = false,
  confirmarAvaliacao = false,
  barrasIncorreto,
}: Props) => {
  const { funcionarioCartorioIsLogged } = useFuncionarioCartorio();
  const { prefeituraIsLogged } = usePrefeitura();
  const { funcionarioPrefeituraIsLogged } = useFuncionarioPrefeitura();
  const { comunicacao } = useComunicacao();
  const location = useLocation();
  const aba_de_pesquisa = location.pathname.indexOf("pesquisar") != -1;

  return (
    <div style={{ position: "fixed", bottom: 0, zIndex: 1 }}>
      <div
        style={{
          width: "100vw",
          display: "flex",
          justifyContent: "center",
          marginBottom: "8px",
          flexWrap: "wrap",
        }}
      >
        <HelperResponsivo>
          {aba_de_pesquisa ? (
            <BottomNavigation
              style={{
                minWidth: "80%",
                backgroundColor: theme.colors.light,
                border: `1px solid ${theme.colors.dark}`,
                borderRadius: "4rem",
                justifyContent: "space-around",
              }}
            >
              <ReactToPrint
                content={() => printComponent}
                trigger={() => (
                  <BottomNavigationAction
                    label="Imprimir"
                    icon={<PrintIcon style={{ color: theme.colors.dark }} />}
                  />
                )}
                onBeforePrint={() => {}}
                onAfterPrint={() => {}}
              />
            </BottomNavigation>
          ) : (
            <BottomNavigation
              style={{
                minWidth: "80%",
                backgroundColor: theme.colors.light,
                border: `1px solid ${theme.colors.dark}`,
                borderRadius: "4rem",
                justifyContent: "space-around",
              }}
            >
              { imovel.AVALIADO == null && (
                <BottomNavigationAction
                  label="Excluir solicitação"
                  icon={
                    <DeleteIcon style={{ color: theme.colors.attention }} />
                  }
                  onClick={onExcluir}
                />
              )}

              {imovel.ENVIADO &&
                !finalizado &&
                (funcionarioPrefeituraIsLogged || prefeituraIsLogged) && (
                  <Button
                    variant="text"
                    color="error"
                    startIcon={<CloseIcon />}
                    onClick={reenviarCartorio}
                  >
                    Reenviar para Cartorio
                  </Button>
                )}

              {!aba_de_pesquisa && (
                <Button
                  variant="text"
                  color="primary"
                  startIcon={<AttachFileIcon />}
                  onClick={executeAnexos}
                >
                  Anexos
                  <Badge
                    badgeContent={countAnexos}
                    color="primary"
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    style={{
                      transform: "scale(0.7)",
                      marginLeft: "5px",
                      marginBottom: "16px",
                    }}
                  />
                </Button>
              )}

              {!aba_de_pesquisa && (
                <Button
                  variant="text"
                  color="primary"
                  startIcon={<ContentCopyIcon />}
                  onClick={duplicar}
                >
                  Duplicar guia
                </Button>
              )}

              {confirmarAvaliacao && !barrasIncorreto && (
                <Button
                  variant="text"
                  color="primary"
                  startIcon={<DoneIcon />}
                  onClick={confirmarAvaliacaoFunction}
                >
                  Confirmar Ou Recusar Avaliação
                </Button>
              )}
              {barrasIncorreto && (
                <Button
                  variant="text"
                  color="error"
                  startIcon={<RefreshIcon />}
                  onClick={() => window.location.reload()}
                >
                  Recarregar Dados(Código Febraban não foi carregado
                  corretamente)
                </Button>
              )}

              {finalizado && !confirmarAvaliacao && (
                <ReactToPrint
                  content={() => printComponent}
                  trigger={() => (
                    <BottomNavigationAction
                      label="Imprimir"
                      icon={<PrintIcon style={{ color: theme.colors.dark }} />}
                    />
                  )}
                  onBeforePrint={() => {}}
                  onAfterPrint={() => {}}
                />
              )}
              {!aba_de_pesquisa && (
                <Button
                  variant="text"
                  color="primary"
                  startIcon={<MessageIcon />}
                  onClick={openMensagem}
                >
                  Mensagens
                  <Badge
                    badgeContent={
                      comunicacao.length ? comunicacao.length - 1 : 0
                    }
                    color="primary"
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    style={{
                      transform: "scale(0.7)",
                      marginLeft: "5px",
                      marginBottom: "16px",
                    }}
                  />
                </Button>
              )}

              {!imovel.ENVIADO && (
                <Button
                  variant="text"
                  color="primary"
                  startIcon={<DoneIcon />}
                  onClick={enviar}
                >
                  Enviar para a avaliação
                </Button>
              )}

              {imovel.ENVIADO &&
                !finalizado &&
                (funcionarioPrefeituraIsLogged || prefeituraIsLogged) && (
                  <Button
                    variant="text"
                    color="primary"
                    startIcon={<DoneIcon />}
                    onClick={finalizarAvaliacao}
                  >
                    FINALIZAR AVALIAÇÃO
                  </Button>
                )}

              {/*<MessageCircle size={"max(1.8vw,16px)"} /> */}
            </BottomNavigation>
          )}
        </HelperResponsivo>
      </div>
    </div>
  );
};
